module.exports = __webpack_public_path__ + "img/0Q3A4226_L_BlackMatted.1ba4ef2d.jpg";